export default __webpack_public_path__ + "static/media/Archdeacon's Helm of the Earthen Prison.1ffc9614.jpg";